import { Timestamp } from '@bufbuild/protobuf/wkt'
import { createConnectQueryKey, useQuery } from '@connectrpc/connect-query'

import {
  daysCompaniesInAssessmentRequired,
  getAlertsCountBySeverityTimeseries,
  getCompaniesCompliances,
  getCountCompaniesBySeverity,
  listAIThirdPartyAlertCountsBySeverity,
  listAIThirdPartyCountsByAssessmentScore,
  listCompaniesWithMostAlerts,
  listDiscoverySolutionCountsByAIPosture,
  listThirdPartyCountsByAICapability,
  listThirdPartyCountsByAIPosture,
  listTopModelProviders,
  ongoingAssessmentsSummary,
} from '@/gen/inventory/v1/statistics_service-StatisticsService_connectquery'
import { StatisticsService } from '@/gen/inventory/v1/statistics_service_pb'

import { defaultTransport } from '@/lib/connect/connect-transport'

import { DEFAULT_TOP_MODEL_PROVIDERS_LIMIT } from './consts'

export const useDaysCompaniesInAssessmentRequired = () => {
  return useQuery(daysCompaniesInAssessmentRequired)
}

export const useAlertsCountBySeverityTimeseries = () => {
  return useQuery(getAlertsCountBySeverityTimeseries)
}

export const getListCompaniesWithMostAlertsQueryKey = () => {
  return createConnectQueryKey({
    schema: StatisticsService.method.listCompaniesWithMostAlerts,
    cardinality: 'finite',
    transport: defaultTransport,
  })
}

export const useCompaniesWithMostAlerts = () => {
  return useQuery(listCompaniesWithMostAlerts)
}

export const useCompaniesBySeverity = (date: Timestamp) => {
  return useQuery(getCountCompaniesBySeverity, { date })
}

export const useOngoingAssessmentsSummary = () => {
  return useQuery(ongoingAssessmentsSummary)
}

export const useGetCompaniesCompliances = () => {
  return useQuery(getCompaniesCompliances)
}

export const useTopModelProviders = (limit: number = DEFAULT_TOP_MODEL_PROVIDERS_LIMIT) => {
  return useQuery(listTopModelProviders, { limit })
}

export const useThirdPartyCountsByAICapability = () => {
  return useQuery(listThirdPartyCountsByAICapability)
}

export const useThirdPartyCountsByAIPosture = () => {
  return useQuery(listThirdPartyCountsByAIPosture)
}

export const useDiscoverySolutionCountsByAIPosture = () => {
  return useQuery(listDiscoverySolutionCountsByAIPosture)
}

export const useAIThirdPartyCountsByAssessmentScore = () => {
  return useQuery(listAIThirdPartyCountsByAssessmentScore)
}

export const useAIThirdPartyAlertCountsBySeverity = () => {
  return useQuery(listAIThirdPartyAlertCountsBySeverity)
}
